import React, { useState, useEffect, createContext, useContext } from 'react';
import { setUnauthorizedHandler, refreshSession } from '../lib/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [user, setUser] = useState(null);

    const checkAuth = async () => {
        try {
            const validateUrl = `${process.env.REACT_APP_BACKEND_URL}auth/validate`;
            let res = await fetch(validateUrl, {
                method: 'GET',
                credentials: 'include',
            });

            //JWT expirado: tenta renovar com refresh cookie (uma vez) e volta a validar
            if (res.status === 401) {
                const refreshed = await refreshSession();
                if (refreshed) {
                    res = await fetch(validateUrl, {
                        method: 'GET',
                        credentials: 'include',
                    });
                }
            }

            if (res.ok) {
                const data = await res.json();
                setIsAuthenticated(true);
                setUser(data.user);
            } else {
                setIsAuthenticated(false);
                setUser(null);
            }
        } catch (error) {
            console.error('Erro ao verificar autenticação:', error);
            setIsAuthenticated(false);
            setUser(null);
        }
    };

    useEffect(() => {
        checkAuth();
    }, []);

    const logout = async () => {
        try {
            await fetch(`${process.env.REACT_APP_BACKEND_URL}auth/signout`, {
                method: 'POST',
                credentials: 'include',
            });
        } catch (error) {
            console.error('Erro ao sair:', error);
        } finally {
            try { localStorage.removeItem('selectedZone'); } catch (_) {}
            setIsAuthenticated(false);
            setUser(null);
        }
    };

    //mid-session 401 after failed- refresh clear auth state
    useEffect(() => {
        setUnauthorizedHandler(() => {
            try { localStorage.removeItem('selectedZone'); } catch (_) {}
            setIsAuthenticated(false);
            setUser(null);
        });
        return () => setUnauthorizedHandler(null);
    }, []);

    return (
        <AuthContext.Provider
            value={{ isAuthenticated, user, setIsAuthenticated, setUser, logout, checkAuth }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
